import React from 'react';
import { Box, Typography, Skeleton, Stack } from '@mui/material';
import HistoryIcon from '@mui/icons-material/History';
import { ChangeEventCard } from './ChangeEventCard';
import type { PageChangeEvent } from '../../types/changeDetection.types';

interface ChangeTimelineProps {
  changes: PageChangeEvent[];
  loading?: boolean;
  onCreateExperiment?: (eventId: number) => void;
}

export const ChangeTimeline: React.FC<ChangeTimelineProps> = ({
  changes,
  loading,
  onCreateExperiment
}) => {
  if (loading) {
    return (
      <Stack spacing={2}>
        {Array.from({ length: 3 }).map((_, idx) => (
          <Skeleton key={idx} variant="rectangular" height={200} sx={{ borderRadius: 1 }} />
        ))}
      </Stack>
    );
  }

  if (!changes || changes.length === 0) {
    return (
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          py: 8,
          textAlign: 'center'
        }}
      >
        <HistoryIcon sx={{ fontSize: 64, color: 'text.secondary', mb: 2 }} />
        <Typography variant="h6" gutterBottom>
          No Changes Detected
        </Typography>
        <Typography variant="body2" color="text.secondary">
          This page has no tracked changes in the selected time period.
        </Typography>
      </Box>
    );
  }

  return (
    <Box>
      {changes.map(event => (
        <ChangeEventCard
          key={event.id}
          event={event}
          onCreateExperiment={onCreateExperiment}
        />
      ))}
    </Box>
  );
};
